import dayjs from 'dayjs';
import formatYesNo from 'src/util/formatYesNo';
import natureOfBusOptions from 'src/constants/natureOfBusOptions.';

export const createBusinessValues = (businessInfo, updatedInfo) => {
  const businessName = businessInfo?.businessName;
  const updatedBusName = updatedInfo?.busName ? updatedInfo?.busName : businessInfo?.businessName;

  const streetAddr = businessInfo?.streetAddr;
  const streetCityline = businessInfo?.streetCityline;
  const mailAddr = updatedInfo?.mailAddr;
  const mailCity = updatedInfo?.mailCity;
  const mailZip = updatedInfo?.mailZip;
  const addrUpdated = mailAddr || mailCity || mailZip;
  const originalMailingAddr = `${streetAddr} ${streetCityline}`;
  const updatedMailingAddr = addrUpdated
    ? `${mailAddr} ${mailCity} ${mailZip}`
    : `${originalMailingAddr}`;

  return [
    {
      label: 'Business Name',
      original: businessName,
      updated: updatedBusName,
    },

    {
      label: 'Mailing Address',
      original: originalMailingAddr,
      updated: updatedMailingAddr,
    },
  ];
};

export const createBusinessLocationValues = (businessInfo, updatedInfo) => {
  const originalBusinessLocation = `${businessInfo?.businessAddr} ${businessInfo?.businessCityline}`;
  const updatedBusinessLocation = updatedInfo?.busLoc
    ? `${updatedInfo?.busLoc} ${updatedInfo?.busCity} ${updatedInfo?.busZip}`
    : originalBusinessLocation;

  const values = [
    {
      label: 'Business Location',
      original: originalBusinessLocation,
      updated: updatedBusinessLocation,
    },
  ];

  if (updatedInfo?.dateBusMoved) {
    values.push({
      label: 'Date Business Moved',
      original: '',
      updated: updatedInfo.dateBusMoved,
    });
  }

  return values;
};

export const createContactInfoValues = (businessContacts, updatedBusinessContacts) => {
  return {
    label: 'Contacts',
    original: businessContacts?.map(
      ({ partyDesc, ownername, owneraddress, ownerzip, ownercityst }) => {
        return [partyDesc, ownername, `${owneraddress} ${ownercityst} ${ownerzip}`];
      }
    ),
    updated: updatedBusinessContacts?.map(
      ({ partyDesc, ownername, owneraddress, ownercityst, ownerzip }) => {
        return [partyDesc, ownername, `${owneraddress} ${ownercityst} ${ownerzip}`];
      }
    ),
  };
};

export const createNatureOfBusinessValues = (businessInfo, updatedInfo) => {
  const natureOfBusOriginal = businessInfo?.nature;
  const natureOfBusUpdated = updatedInfo?.natureOfBus
    ? natureOfBusOptions[updatedInfo?.natureOfBus]
    : businessInfo?.nature;

  const ownerTypeOriginal = businessInfo?.ownerType;
  const ownershipTypeUpdated = updatedInfo?.ownershipType
    ? updatedInfo?.ownershipType
    : businessInfo?.ownerType;

  const dateOpenedOriginal = businessInfo?.locOpen
    ? dayjs(businessInfo?.locOpenDate).format('MM-DD-YYYY')
    : '';
  const dateOpenedUpdated = updatedInfo?.dateOpenedLoc
    ? dayjs(updatedInfo?.dateOpenedLoc).format('MM-DD-YYYY')
    : businessInfo?.locOpen
    ? dayjs(businessInfo?.locOpenDate).format('MM-DD-YYYY')
    : '';

  const homeBusinessOriginal = businessInfo?.homebusiness;
  const homeBusinessUpdated = updatedInfo?.homebiz
    ? updatedInfo?.homebiz
    : businessInfo?.homebusiness;

  const naicsCodeOriginal = businessInfo?.naicsCode;
  const naicsCodeUpdated = updatedInfo?.naicsCode
    ? updatedInfo?.naicsCode
    : businessInfo?.naicsCode;

  const dbaNameCodeOriginal = businessInfo?.dbaName;
  const dbaNameCodeUpdated = updatedInfo?.dbaName ? updatedInfo?.dbaName : businessInfo?.dbaName;

  return [
    {
      label: 'Type',
      original: `${natureOfBusOriginal} / ${ownerTypeOriginal}`,
      updated: `${natureOfBusUpdated} / ${ownershipTypeUpdated}`,
    },
    {
      label: 'Home Business',
      original: homeBusinessOriginal,
      updated: formatYesNo(homeBusinessUpdated),
    },
    {
      label: 'Date Opened',
      original: dateOpenedOriginal,
      updated: dateOpenedUpdated,
    },
    {
      label: 'NAICS code',
      original: naicsCodeOriginal,
      updated: naicsCodeUpdated,
    },
    {
      label: 'DBA Name',
      original: dbaNameCodeOriginal,
      updated: dbaNameCodeUpdated,
    },
  ];
};

export const createLeasedAssetSummaryValues = (leasedAssets) => {
  return [
    {
      label: 'Number of leased Assets',
      updated: leasedAssets?.qty,
    },
  ];
};

export const defaultEmptyString = (val) => {
  return val ? val : '';
};

export const handlePaperlessFlag = (val) => {
  if (val === 1) {
    return 'Yes';
  } else if (val === 0) {
    return 'No';
  } else {
    return val ? val : '';
  }
};
